/**
 *
 * @module telemetryManagerExtrasMap
 *
 */

import Check from 'check-types';
import Logging from './../../logging/entry';
import Exception from './../../services/exception/entry';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    nonEmptyObject
} = Check.assert;

/**
 *
 * @class TelemetryManagerExtrasMap
 * @desc Provides additional configuration information used by the manager.
 *
 */
export default class TelemetryManagerExtrasMap {

    /**
     *
     * @param {Object} options
     * @param {Number} options.batchLimit
     * @param {Number} options.replyAfterFallback
     * @param {Number} options.minimumBatchSize
     * @param {Object} options.bufferConfigurationDefault
     * @param {Object} [options.streamSampleConfiguration=null]
     * @param {SDK.Logging.Logger} [options.logger=Logging]
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: `${this.constructor.name}(options)`,
            get options() {
                return `${this.ctor} options should be a non-empty Object`;
            },
            get batchLimit() {
                return `${this.ctor} options.batchLimit should be a Number`;
            },
            get replyAfterFallback() {
                return `${this.ctor} options.replyAfterFallback should be a Number`;
            },
            get minimumBatchSize() {
                return `${this.ctor} options.minimumBatchSize should be a Number`;
            },
            get bufferConfigurationDefault() {
                return `${this.ctor} options.bufferConfigurationDefault should be a Object`;
            },
            get streamConfigurationDefault() {
                return `${this.ctor} options.streamConfiguration should be a Object`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { batchLimit, replyAfterFallback, minimumBatchSize, bufferConfigurationDefault } = options;
        const { streamSampleConfiguration = null, logger = Logging } = options;

        if (Check.not.number(batchLimit)) {
            logger.warn('TelemetryManagerExtrasMap', errorMessage.batchLimit);
        }

        if (Check.not.number(replyAfterFallback)) {
            logger.warn('TelemetryManagerExtrasMap', errorMessage.replyAfterFallback);
        }

        if (Check.not.number(minimumBatchSize)) {
            logger.warn('TelemetryManagerExtrasMap', errorMessage.minimumBatchSize);
        }

        if (Check.not.object(bufferConfigurationDefault)) {
            logger.warn('TelemetryManagerExtrasMap', errorMessage.bufferConfigurationDefault);
        }

        if (Check.not.object(streamSampleConfiguration)) {
            logger.warn('TelemetryManagerExtrasMap', errorMessage.streamSampleConfiguration);
        }

        /**
         *
         * @access public
         * @type {Number}
         * @desc Gets or sets the batch limit.
         *
         */
        this.batchLimit = batchLimit;

        /**
         *
         * @access public
         * @type {Number}
         * @desc Gets or sets the reply after fallback interval in seconds.
         *
         */
        this.replyAfterFallback = replyAfterFallback;

        /**
         *
         * @access public
         * @type {Number}
         * @desc the minimum number of events needed before they can be posted
         *
         */
        this.minimumBatchSize = minimumBatchSize;

        /**
         *
         * @access public
         * @type {Object}
         * @desc default event buffer configuration
         *
         */
        this.bufferConfigurationDefault = bufferConfigurationDefault;

        /**
         *
         * @access public
         * @type {Object|null}
         * @desc optional stream buffer configuration
         *
         */
        this.streamSampleConfiguration = streamSampleConfiguration || bufferConfigurationDefault;

    }

}



// WEBPACK FOOTER //
// ./src/services/configuration/telemetryManagerExtrasMap.js